var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { NagPlacenameResoComponent } from 'app/components/content-config/config-nag/nag-placename-reso/nag-placename-reso.component';
import { ActivityService } from 'app/services/activity.service';
import { AgencyInfoService } from 'app/services/agency-info.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { DomainService } from 'app/services/domain.service';
import { EditService } from 'app/services/edit.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { MainDataService } from 'app/services/main-data.service';
import { NagService } from 'app/services/nag.service';
import { ResolutionCenterDomainService } from 'app/services/resolution-center-domain.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
var DomainResolutionInspectorComponent = /** @class */ (function () {
    function DomainResolutionInspectorComponent(toastr, activityService, agencyInfoService, appinfoService, attrIndexService, commonService, domainService, editService, gfoService, mainDataService, modalService, nagService, resoCenterDomainService, qcService, tooltipHelpService, userService) {
        this.toastr = toastr;
        this.activityService = activityService;
        this.agencyInfoService = agencyInfoService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.domainService = domainService;
        this.editService = editService;
        this.gfoService = gfoService;
        this.mainDataService = mainDataService;
        this.modalService = modalService;
        this.nagService = nagService;
        this.resoCenterDomainService = resoCenterDomainService;
        this.qcService = qcService;
        this.tooltipHelpService = tooltipHelpService;
        this.userService = userService;
        this.showNagOperator = true;
        this.qaResolverFeeds = [];
    }
    DomainResolutionInspectorComponent.prototype.discard = function () {
        if (this.selectedColumn) {
            this.selectedColumn.currentValueList.forEach(function (i) { return i.newValue = undefined; });
        }
        this.hasChanged = false;
    };
    DomainResolutionInspectorComponent.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, changedCols_1, layer_1, layerCate_1, sourceTableName_1, prefix_1, primKeyCol_1, colProp_1, generalColType_1, cols_1, colsWithName_1, gtoAll_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        changedCols_1 = {};
                        layer_1 = this.activityService.selectedLayerBS.getValue().layer;
                        layerCate_1 = layer_1.category;
                        sourceTableName_1 = layerCate_1.tableName;
                        prefix_1 = layerCate_1.colPrefix;
                        primKeyCol_1 = this.editService.getPrimKeyCol(prefix_1);
                        colProp_1 = this.selectedColumn.col.prop;
                        generalColType_1 = this.appinfoService.findGeneralCol(this.selectedColumn.col.lbType);
                        cols_1 = this.editService.getUpdateColsInSourceTable(sourceTableName_1, prefix_1);
                        colsWithName_1 = cols_1.map(function (c) {
                            return {
                                prop: c,
                                name: _this.appinfoService.columnMap[c] ? _this.appinfoService.columnMap[c].heading : ''
                            };
                        });
                        gtoAll_1 = [];
                        this.selectedColumn.currentValueList.forEach(function (i) {
                            changedCols_1 = {};
                            if (_this.selectedColumn.col.standardName === _this.nguidStandardName) {
                                var split = '__splitString__';
                                var nguidClause = _this.agencyInfoService.computeNguid(layerCate_1.code, split);
                                var splits = nguidClause.split(split);
                                nguidClause = "'" + splits[0] + "' || " + layerCate_1.colPrefix + "_globalid || '" + splits[1] + "'";
                                changedCols_1[_this.selectedColumn.col.prop] = {
                                    val: nguidClause,
                                    isExpression: true
                                };
                            }
                            else {
                                if ((i.newValue || i.newValue === 0) && i.isValid) {
                                    var format = _this.editService.formatClauseValForGto(i.newValue, generalColType_1, colsWithName_1);
                                    changedCols_1[colProp_1] = {
                                        val: format.val,
                                        isExpression: format.isExpression
                                    };
                                }
                            }
                            var filter;
                            if (i.value === null) {
                                filter = _this.gfoService.getFilter(colProp_1, _this.appinfoService.filterOperators['is null'].name, null);
                            }
                            else {
                                filter = _this.gfoService.getFilter(colProp_1, _this.appinfoService.filterOperators.eq.name, i.value);
                            }
                            var whereClause = _this.editService.getWhereClauseFromColumnFilters([filter]);
                            // Add layer id
                            var layerIdWhere = prefix_1 + "_" + _this.attrIndexService.layerIdColumn + " = " + layer_1.id;
                            whereClause = _this.editService.addToWhereClause(whereClause, layerIdWhere);
                            // Exclude deleted record
                            var notDeletedWhere = prefix_1 + "_" + _this.attrIndexService.tranxDeleteColName + " IS NULL";
                            whereClause = _this.editService.addToWhereClause(whereClause, notDeletedWhere);
                            var gtos = _this.editService.getUpdateGtosBatch(sourceTableName_1, whereClause, changedCols_1, cols_1, primKeyCol_1, prefix_1).gtos;
                            gtoAll_1 = gtoAll_1.concat(gtos);
                        });
                        if (!gtoAll_1.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.editService.commitGtoAndQcForBach(gtoAll_1, [this.selectedColumn.col.prop], layer_1.id, prefix_1)];
                    case 2:
                        _a.sent();
                        this.discard();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    DomainResolutionInspectorComponent.prototype.onComputeNguid = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commit()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DomainResolutionInspectorComponent.prototype.toggleExpand = function (item) {
        item.isExpand = !item.isExpand;
        if (item.isExpand) { // Close other expanded items
            this.feedItemList.forEach(function (i) { return i.isExpand = i === item; });
        }
    };
    DomainResolutionInspectorComponent.prototype.clickColumn = function (col, rule, force) {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = this.resoCenterDomainService.domainValuesByRule;
                        if (!data[rule]) {
                            data[rule] = {};
                        }
                        if (!data[rule][col.prop]) {
                            data[rule][col.prop] = [];
                        }
                        if (!(!data[rule][col.prop].length || force)) return [3 /*break*/, 5];
                        this.commonService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.resoCenterDomainService.getQaResolverFeedsDomainValues(this.layerId, rule, col.standardName, col.prop)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false);
                        _a.label = 5;
                    case 5:
                        this.selectedColumn = {
                            col: col,
                            rule: rule,
                            currentValueList: data[rule][col.prop],
                            domain: this.domainsByColumn[col.prop],
                            nagParam: this.appinfoService.nagParams.find(function (c) { return c.standardName === col.standardName; })
                        };
                        this.colType = this.appinfoService.columnMap[col.prop] ? this.appinfoService.columnMap[col.prop].type : null;
                        // Set county and states domain
                        this.isCountyCol = col.standardName === this.attrIndexService.countyColNameStandard || col.standardName === this.attrIndexService.countyLeftColStandard || col.standardName === this.attrIndexService.countyRightColStandard;
                        this.isStateCol = col.standardName === this.attrIndexService.stateColNameStandard || col.standardName === this.attrIndexService.stateLeftColStandard || col.standardName === this.attrIndexService.stateRightColStandard;
                        if (this.isStateCol) {
                            this.stateNeighborList = this.userService.getStatesFromNeighborCounties();
                            if (this.selectedColumn.domain && this.selectedColumn.domain.type === 'list' && this.selectedColumn.domain.list) {
                                this.selectedColumn.domain.list.forEach(function (l) {
                                    var idx = _this.stateNeighborList.indexOf(l);
                                    if (idx > -1) {
                                        _this.stateNeighborList.splice(idx, 1);
                                    }
                                });
                            }
                        }
                        if (this.isCountyCol) {
                            this.countyNeighborList = this.userService.getNeighborCountiesFromCustomer();
                            if (this.selectedColumn.domain && this.selectedColumn.domain.type === 'list' && this.selectedColumn.domain.list) {
                                this.selectedColumn.domain.list.forEach(function (l) {
                                    var idx = _this.countyNeighborList.findIndex(function (i) { return i.value === l; });
                                    if (idx > -1) {
                                        _this.countyNeighborList.splice(idx, 1);
                                    }
                                });
                            }
                        }
                        //
                        this.ruleCode = rule;
                        // Auto fill for discrepancy id
                        if (this.selectedColumn.col.standardName.toLowerCase() === this.attrIndexService.discrepancyAgencyIdStandardLower) {
                            this.selectedColumn.currentValueList.forEach(function (i) {
                                i.newValue = _this.userService.customerInfo.discrepancyId;
                            });
                        }
                        else if (this.selectedColumn.col.standardName.toLowerCase() === this.attrIndexService.nguidCol.toLowerCase()) {
                        }
                        this.checkShowNagOperator(rule);
                        return [2 /*return*/];
                }
            });
        });
    };
    DomainResolutionInspectorComponent.prototype.onEdit = function () {
        this.hasChanged = true;
    };
    DomainResolutionInspectorComponent.prototype.checkCommitDisable = function () {
        if (this.hasChanged) {
            return false;
        }
        if (this.selectedColumn) {
            var colName = this.selectedColumn.col.standardName.toLowerCase();
            if (colName === this.attrIndexService.discrepancyAgencyIdStandardLower || colName === this.attrIndexService.nguidCol.toLowerCase()) {
                return false;
            }
        }
        return true;
    };
    DomainResolutionInspectorComponent.prototype.checkValidity_input = function (item) {
        var check = this.editService.checkClauseVal(item.newValue, {
            prop: this.selectedColumn.col.prop,
            type: this.appinfoService.findGeneralCol(this.selectedColumn.col.lbType)
        }, this.domainsByColumn);
        item.isValid = check.isValid && !this.checkChangedValueIsSameAsOrigin(item);
    };
    DomainResolutionInspectorComponent.prototype.checkValidity_domain = function (item) {
        item.isValid = !this.checkChangedValueIsSameAsOrigin(item);
    };
    // If value has changed, check if it's changed to the same value as before // If value hasn't been changed then ignore
    DomainResolutionInspectorComponent.prototype.checkChangedValueIsSameAsOrigin = function (item) {
        return (item.newValue !== undefined && !this.editService.hasValueChanged(item.newValue, item.value));
    };
    // Only update lastTooltips if the mouse is hovering over the cell more than 1 second
    DomainResolutionInspectorComponent.prototype.onMouseoverCode = function (code) {
        var _this = this;
        this.mouseoverCodeTimeout = setTimeout(function () {
            _this.tooltipHelpService.lastTooltipsBS.next({
                codes: [code]
            });
        }, this.tooltipHelpService.delayTime);
    };
    DomainResolutionInspectorComponent.prototype.onMouseoutCode = function () {
        if (this.mouseoverCodeTimeout) {
            clearTimeout(this.mouseoverCodeTimeout);
        }
    };
    DomainResolutionInspectorComponent.prototype.checkDisableInput = function () {
        if (this.selectedColumn && this.selectedColumn.col.standardName.toLowerCase() === this.attrIndexService.discrepancyAgencyIdStandardLower) {
            return true;
        }
    };
    DomainResolutionInspectorComponent.prototype.addToNag = function (i) {
        return __awaiter(this, void 0, void 0, function () {
            var nagParam, isPlaceName, cusCounties_1, countyList, _a, data, options, result, standardRecords, standard, err_3, selectedCol, layer, qaResolverFeeds_domain, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nagParam = this.selectedColumn.nagParam;
                        if (!nagParam) return [3 /*break*/, 23];
                        isPlaceName = nagParam.nctName.startsWith(this.attrIndexService.placenameNagName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 22, , 23]);
                        if (!isPlaceName) return [3 /*break*/, 11];
                        cusCounties_1 = this.userService.customerInfo.cusCounties || [];
                        _a = this.countyList;
                        if (_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.agencyInfoService.getCounties()];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        countyList = _a;
                        this.countyList = countyList.filter(function (c) { return cusCounties_1.indexOf(c.name) > -1; });
                        data = {
                            standard: {
                                name: i.value
                            },
                            countyList: this.countyList,
                            nctId: nagParam.nctId
                        };
                        options = {
                            data: data,
                            height: '400px',
                            width: '600px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(NagPlacenameResoComponent, options)];
                    case 4:
                        result = _b.sent();
                        if (!result) return [3 /*break*/, 9];
                        if (!result.existingRec) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.nagService.editStandard_location(nagParam.nctId, result.existingRec.stnId, result.standardName, result.placeTypes, result.county.stnId)];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.nagService.addStandard_location(nagParam.nctId, result.standardName, result.placeTypes, result.county.stnId)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9: return [2 /*return*/];
                    case 10: return [3 /*break*/, 16];
                    case 11: return [4 /*yield*/, this.nagService.getNagNamesStandardId(i.value, nagParam.nctId, this.userService.customerInfo.givState)];
                    case 12:
                        standardRecords = _b.sent();
                        standard = standardRecords[0];
                        if (!standard) return [3 /*break*/, 14];
                        return [4 /*yield*/, this.nagService.editStandard_street(nagParam.nctId, standard.stnId, i.value, nagParam.source)];
                    case 13:
                        _b.sent();
                        return [3 /*break*/, 16];
                    case 14: return [4 /*yield*/, this.nagService.addStandard_street(nagParam.nctId, i.value, nagParam.source)];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        this.toastr.success('Successfully added.');
                        this.commonService.setLoadingSpinner(true);
                        _b.label = 17;
                    case 17:
                        _b.trys.push([17, 19, , 20]);
                        return [4 /*yield*/, this.qcService.qcLayerIncNag([nagParam.nctName])];
                    case 18:
                        _b.sent();
                        return [3 /*break*/, 20];
                    case 19:
                        err_3 = _b.sent();
                        console.log(err_3);
                        this.toastr.error('QC failed.');
                        return [3 /*break*/, 20];
                    case 20:
                        this.commonService.setLoadingSpinner(false);
                        selectedCol = this.selectedColumn;
                        layer = this.activityService.selectedLayerBS.getValue().layer;
                        return [4 /*yield*/, this.resoCenterDomainService.getQaResolverFeedsDomain(layer.id, layer.category.code)];
                    case 21:
                        qaResolverFeeds_domain = _b.sent();
                        this.resoCenterDomainService.resoFeedDomainBS.next({
                            feeds: qaResolverFeeds_domain,
                            layerId: layer.id,
                            selectedRule: this.ruleCode,
                            selectedColProp: selectedCol.col.prop
                        });
                        // Refresh data
                        this.activityService.refreshData.next();
                        return [3 /*break*/, 23];
                    case 22:
                        err_4 = _b.sent();
                        console.log(err_4);
                        return [3 /*break*/, 23];
                    case 23: return [2 /*return*/];
                }
            });
        });
    };
    DomainResolutionInspectorComponent.prototype.checkShowNagOperator = function (ruleCode) {
        this.showNagOperator = this.userService.getUserInfo().isAdmin && ruleCode === 'DLS';
    };
    DomainResolutionInspectorComponent.prototype.clearAll = function () {
        // TODO
    };
    DomainResolutionInspectorComponent.prototype.onFeedChange = function () {
        var _this = this;
        this.selectedColumn = null;
        this.colType = null;
        this.feedItemList = this.qaResolverFeeds.map(function (i) {
            var info = _this.mainDataService.qcFilterInfo.getValue();
            var ruleInfo = info.filterOptions.find(function (o) { return o.value === i.rule; });
            return {
                rule: {
                    code: i.rule,
                    descShort: ruleInfo ? ruleInfo.name : '',
                    descLong: ruleInfo ? ruleInfo.descriptionLong : ''
                },
                count: i.count,
                cols: i.cols,
                isExpand: false
            };
        });
        var layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
        var cols = [];
        // Get all columns insead of just those that are involved, since some domains are dependent on columns that are not involved 
        // this.feedItemList.forEach(i => i.cols.forEach(c => cols.push({
        // 	prop: c.prop,
        // 	standard: layerCate.standardCols.find(s => s.colName === c.standardName)
        // })));
        layerCate.standardCols.forEach(function (s) {
            cols.push({
                prop: layerCate.colPrefix + '_' + s.colName.toLowerCase(),
                standard: s
            });
        });
        this.domainsByColumn = this.domainService.getColumnDomains(cols, layerCate.code);
    };
    DomainResolutionInspectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.nguidStandardName = this.attrIndexService.nguidCol;
        this.discrepancyId = this.userService.customerInfo.discrepancyId;
        this.nguidPattern = JSON.parse(JSON.stringify(this.userService.customerInfo.nguidPattern));
        this.resoFeedSub = this.resoCenterDomainService.resoFeedDomainBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            var expand, col;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resoCenterDomainService.domainValuesByRule = {};
                        if (!data || !data.feeds) {
                            this.clearAll();
                            return [2 /*return*/];
                        }
                        this.layerId = data.layerId;
                        this.qaResolverFeeds = data.feeds;
                        this.onFeedChange();
                        if (!data.selectedRule) return [3 /*break*/, 2];
                        expand = this.feedItemList.find(function (i) { return i.rule.code === data.selectedRule; });
                        if (expand && !expand.isExpand) {
                            this.toggleExpand(expand);
                        }
                        if (!(expand && data.selectedColProp)) return [3 /*break*/, 2];
                        col = expand.cols.find(function (c) { return c.prop === data.selectedColProp; });
                        if (!col) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.clickColumn(col, this.ruleCode, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    DomainResolutionInspectorComponent.prototype.ngOnDestroy = function () {
        this.resoFeedSub.unsubscribe();
    };
    return DomainResolutionInspectorComponent;
}());
export { DomainResolutionInspectorComponent };
